import { render, staticRenderFns } from "./payment_gateway_configuration.vue?vue&type=template&id=4d1face4&"
import script from "./payment_gateway_configuration.vue?vue&type=script&lang=js&"
export * from "./payment_gateway_configuration.vue?vue&type=script&lang=js&"
import style0 from "./payment_gateway_configuration.vue?vue&type=style&index=0&id=4d1face4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports